import { sessionStorageAction } from '@vindr/utils/helpers/storage';
import { ImmerReducer } from 'use-immer';

export type GlobalAction = { type: 'SET_SPLIT_VIEW'; payload: boolean };

export type GlobalState = {
  splitView: boolean;
};

export const global_key = 'globalSetting';

export const globalInitialState: GlobalState = sessionStorageAction.get(global_key, {
  splitView: true,
});

export const globalReducer: ImmerReducer<GlobalState, GlobalAction> = (state, action) => {
  switch (action.type) {
    case 'SET_SPLIT_VIEW':
      state.splitView = action.payload;
      break;
    default:
      break;
  }
  sessionStorageAction.set(global_key, state);
};
